import type {
  ClientItemPayload,
  ClientItemResponse,
  ClientsPayload,
  ClientsResponse,
  Client,
  CreateClientItemPayload,
  AddBonusPayload,
} from '@/types/clients'
import type { DefaultDeletePayload, DeleteSuccessResponse, ItemPayload } from '../types/main'
import axios from 'axios'

const BASE_PATH = '/dashboard/v1/chief/customers'

const getClientsCall = async (
  abortController?: AbortController,
  params?: ClientsPayload,
): Promise<ClientsResponse> => {
  const { data } = await axios.get(BASE_PATH, {
    signal: abortController?.signal,
    params,
  })
  return data.data
}

const getClientsForSelectCall = async (abortController?: AbortController): Promise<Client[]> => {
  const { data } = await axios.get(`${BASE_PATH}/dropout`, {
    signal: abortController?.signal,
  })
  return data.data
}

const getClientItemCall = async (
  abortController?: AbortController,
  params?: ItemPayload,
): Promise<ClientItemResponse> => {
  const { data } = await axios.get(`${BASE_PATH}/${params?.id}`, {
    signal: abortController?.signal,
  })
  return data
}

const sendGeneratedPasswordCall = async (
  abortController?: AbortController,
  params?: ItemPayload,
): Promise<DeleteSuccessResponse> => {
  const { data } = await axios.post(
    `${BASE_PATH}/${params?.id}/send-password`,
    {},
    {
      signal: abortController?.signal,
    },
  )
  return data.data
}

const createClientItemCall = async (
  abortController?: AbortController,
  params?: CreateClientItemPayload,
): Promise<Client> => {
  const { data } = await axios.post(
    BASE_PATH,
    { ...params },
    {
      signal: abortController?.signal,
    },
  )
  return data.data
}

const editClientItemCall = async (
  abortController?: AbortController,
  params?: ClientItemPayload,
): Promise<ClientItemResponse> => {
  const { data } = await axios.put(
    `${BASE_PATH}/${params?.id}`,
    { ...params?.data },
    {
      signal: abortController?.signal,
    },
  )
  return data
}

const addBonusToClientItemCall = async (
  abortController?: AbortController,
  params?: AddBonusPayload,
): Promise<ClientItemResponse> => {
  const { data } = await axios.post(
    `${BASE_PATH}/${params?.id}/bonus`,
    { ...params?.data },
    {
      signal: abortController?.signal,
    },
  )
  return data
}

const deleteClientItemCall = async (
  abortController?: AbortController,
  params?: DefaultDeletePayload,
): Promise<DeleteSuccessResponse> => {
  const { data } = await axios.delete(`${BASE_PATH}/${params?.id}`, {
    signal: abortController?.signal,
  })
  return data.data
}

export {
  addBonusToClientItemCall,
  createClientItemCall,
  deleteClientItemCall,
  editClientItemCall,
  getClientItemCall,
  getClientsCall,
  getClientsForSelectCall,
  sendGeneratedPasswordCall,
}
